module.exports = __webpack_public_path__ + "static/media/picto_parcour_parier.efec44c1.png";